export const FILTER_TYPES = {
    TEXT: 'text',
    NUMBER: 'number',
    DATE: 'date',
    DATE_RANGE: 'daterange',
    BOOLEAN: 'boolean',
    SELECT: 'select',
};
